<template>
    <div class="node-area-icon" v-if="icon">
        <v-icon size="small" class="ma-4">{{ icon }}</v-icon>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES, initEmploymentField } from "@/assets/variables";

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentField>} */
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
    },
    data: () => ({
        EMPLOYMENT_FIELD_TYPES,
    }),
    computed: {
        icon() {
            switch (this.mode) {
                case "done": {
                    return;
                }
                case "view": {
                    if (this.value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value) return;
                    break;
                }
                case "sign": {
                    if (this.value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value) return;
                    break;
                }
            }
            return EMPLOYMENT_FIELD_TYPES[this.value.type]?.icon;
        },
    },
};
</script>

<style lang="scss" scoped>
.node-area-icon {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    z-index: -1;
}
</style>
